if ((typeof Theme) === 'undefined') { Theme = {}; }

Theme.htmlDecode = function(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
};

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
});

/** NAVIGATION UX **/
if( window.innerWidth > 1200 ) {

  var navTierOneList = [].slice.call(document.querySelectorAll('.navbar-nav.tier-1 > .dropdown'))
  var navTierOne = navTierOneList.map(function (target) {
    target.addEventListener('mouseover', function(ele) {
      navTierOneList.forEach((element) => { element.classList.remove('open'); });
      ele.classList.add('open');
      var mainNavOverlay = document.createElement("div");
      mainNavOverlay.classList.add('mainNavOverlay');
      document.document.querySelector('main').prepend(mainNavOverlay);
    });
    target.addEventListener('mouseout', function(ele) {
      ele.classList.remove('open');
      var mainNavOverlay = document.querySelector(".mainNavOverlay:not(.cart)");
      if(mainNavOverlay) { mainNavOverlay.remove(); }
    });
  });

} else {
  var headerNav = document.getElementById('mainNavbar');

  var navbarToggle = document.querySelector('.navbar-toggler');
  if( navbarToggle ) {
    navbarToggle.addEventListener('click', function(ele) {
      console.log('--navbar toggle');
      headerNav.classList.toggle('open');
      headerNav.querySelector('.dropdown.open').classList.remove('open');
    });
  };

  var navTierOneList = [].slice.call(document.querySelectorAll('.navbar-nav.tier-1 > .dropdown > .dropdown-toggle'))
  var navTierOne = navTierOneList.map(function (target) {
    target.addEventListener('click', function(evt) {
      target.parentNode.classList.toggle('open');
      headerNav.classList.add('open');
    });
  });

  var navTierTwoList = [].slice.call(document.querySelectorAll('.navbar-nav.tier-2 > .dropdown'))
  var navTierTwo = navTierTwoList.map(function (target) {
    target.addEventListener('click', function(evt) {
      /*
      for (var sibling of target.parentNode.children) {
        if (sibling !== this) sibling.classList.remove('open');
      }
      */
      target.classList.add('open');
    });
  });

  var navBackButtonList = [].slice.call(document.querySelectorAll('.a.menu-back'))
  var navbackButton = navBackButtonList.map(function (target) {
    target.addEventListener('click', function(evt) {
      headerNav.classList.remove('open');
      headerNav.querySelector('.dropdown.open').classList.remove('open');
    });
  });

}
/** END NAVIGATION UX **/